export const copyButtonLinkHandler = () => {
    const copyLinkBtn = document.querySelectorAll(".copyLinkBtn");
    const newArticlePage =
        document.querySelector(".article-page-skin-layout") ||
        document.querySelector(".article-page-two-column-layout") ||
        document.querySelector('[data-article-type="pressbox"]') || document.querySelector(".article-page-new");

    if (copyLinkBtn && newArticlePage) {
        copyLinkBtn.forEach((copyBtn) => {
            copyBtn.addEventListener("click", async () => {
                const link = copyBtn.getAttribute("data-url");

                try {
                    // Copy current URL
                    await navigator.clipboard.writeText(link);

                    // Create message element
                    const msg = document.createElement("span");
                    msg.textContent = "Link copied";
                    msg.className =
                        "pointer-events-none w-max absolute bottom-full right-0 mb-2 rounded bg-d1 px-2 py-1 text-xs text-white opacity-0 transition-opacity";

                    // Append to button container
                    copyBtn.parentElement.style.position = "relative"; // ensure parent is relative
                    copyBtn.parentElement.appendChild(msg);

                    // Trigger fade in
                    requestAnimationFrame(() => {
                        msg.classList.remove("opacity-0");
                        msg.classList.add("opacity-100");
                    });

                    //Remove after 1.5s
                    setTimeout(() => {
                        msg.remove();
                    }, 1500);
                } catch (err) {
                    console.error("Copy failed", err);
                }
            });
        });
    }
};
